// extracted by mini-css-extract-plugin
export var alternate = "_14-j";
export var black = "_14-6";
export var blue = "_14-f";
export var blueLight = "_14-e";
export var brand = "_14-8";
export var darkMode = "_14-b";
export var error = "_14-a";
export var gray = "_14-5";
export var grayBlue = "_14-d";
export var iconWrapper = "_14-3";
export var inactive = "_14-7";
export var indigo = "_14-g";
export var orange = "_14-i";
export var pink = "_14-h";
export var primary = "_14-0";
export var purple = "_14-9";
export var success = "_14-4";
export var warning = "_14-c";
export var white = "_14-1";
export var whiteSuccess = "_14-2";